export default function Knob({ label, value, min = 0, max = 1, step = 0.01, onChange, unit = "", testid }) {
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div className="flex flex-col items-stretch gap-1.5">
      <div className="flex items-center justify-between">
        <span className="text-[9px] tracking-[0.25em] uppercase text-ink-dim">{label}</span>
        <span className="text-[10px] text-brand-red font-mono">
          {typeof value === "number" ? value.toFixed(step < 1 ? 2 : 0) : value}
          {unit}
        </span>
      </div>
      <div className="relative">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(parseFloat(e.target.value))}
          className="knob w-full"
          data-testid={testid}
        />
        <div
          className="absolute left-0 top-1/2 -translate-y-1/2 h-1 pointer-events-none"
          style={{ width: `${pct}%`, background: "linear-gradient(90deg, #FF003C, #8B00FF)" }}
        />
      </div>
    </div>
  );
}
